import { useMemo, useState } from "react";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal.js";
import { ConfirmModalContext } from "./ConfirmModalProvider.context.js";
import { ConfirmModalProviderProps, IProviderConfirmModal } from "./ConfirmModalProvider.types.js";

export const ConfirmModalProvider = ({ children }: ConfirmModalProviderProps): JSX.Element => {
    const [modals, setModals] = useState<Array<IProviderConfirmModal>>([]);

    const addModal = (modal: IProviderConfirmModal) => {
        setModals((prevModals) => [...prevModals, modal]);
    };

    const removeModal = (id: string) => {
        setModals((prevModals) => prevModals.filter((modal) => modal.id !== id));
    };

    const value = useMemo(() => ({ modals, addModal, removeModal }), [modals, addModal, removeModal]);

    return (
        <ConfirmModalContext.Provider value={value}>
            <>
                {modals.map(({ id, modalProps, ...attributes }) => (
                    <ConfirmModal key={id} {...modalProps} {...attributes} isOpen onClose={() => removeModal(id)} />
                ))}

                {children}
            </>
        </ConfirmModalContext.Provider>
    );
};
